// document.addEventListener("DOMContentLoaded", function() {
//   var thumbs = new Swiper('.product--thumbnail_slider .product-thumbs .thumbnail-list', {
//     slidesPerView: 'auto',
//     spaceBetween: 24,
//     centeredSlides: true,
//     slideToClickedSlide: true,
//     loop: true,
//     mousewheel: {
//       releaseOnEdges: true,
//       eventsTarget: "container",
//     }
//   });

//   var slider = new Swiper('.product--thumbnail_slider .product__media-list', {
//     slidesPerView: 1,
//     loop: true,
//     thumbs: {
//       swiper: thumbs,
//     }
    
//   });

// });

window.productThumbnailSlider = function (){
  var thumbs = new Swiper('.product--thumbnail_slider .product-thumbs .thumbnail-list', {
    slidesPerView: 'auto',
    spaceBetween: 24,
    centeredSlides: false,
    slideToClickedSlide: true,
    loop: true,
    mousewheel: {
      releaseOnEdges: true,
      eventsTarget: "container",
    }
  });

  var slider = new Swiper('.product--thumbnail_slider .product__media-list', {
    slidesPerView: 1,
    loop: true,
    thumbs: {
      swiper: thumbs,
    }
    
  });
}

window.productThumbnailSlider();

window.complementarySlider = function() {
    console.log('complementary-slider init');
    document.querySelectorAll('.complementary-slider').forEach(function (node) {
      // Count slides (optional)
      node.slidesQuantity = node.querySelectorAll('.swiper-slide').length;

      // Init Swiper
      new Swiper(node, {
        slidesPerView: 'auto',
        spaceBetween: 16,
        loop: false,
        autoplay: false,
        draggable: true
      });
    });
  };

  // Call the function after DOM is ready
  window.complementarySlider();

// document.addEventListener("DOMContentLoaded", function() {

//   // complementary slider

//   window.complementarySlider = function() {
//     console.log('complementary-slider init');
//     document.querySelectorAll('.complementary-slider').forEach(function (node) {
//       // Count slides (optional)
//       node.slidesQuantity = node.querySelectorAll('.swiper-slide').length;

//       // Init Swiper
//       new Swiper(node, {
//         slidesPerView: 1,
//         spaceBetween: 16,
//         loop: false,
//         autoplay: false,
//         draggable: true,
//         breakpoints: {
//           920: {
//             slidesPerView: 1,
//           },
//           1199: {
//             slidesPerView: 2,
//           },
//         },
//       });
//     });
//   };

//   // Call the function after DOM is ready
//   window.complementarySlider();

// });


// // Review video
// // Store YouTube player instances
// document.addEventListener('DOMContentLoaded', function () {
//   const youtubePlayers = new Map();

//   // Wait for YouTube API to be ready
//   window.onYouTubeIframeAPIReady = () => {
//     document.querySelectorAll('.review_img_video iframe[src*="youtube"]').forEach((iframe) => {
//       const player = new YT.Player(iframe, {
//         events: {
//           onReady: () => {
//             youtubePlayers.set(iframe, player);
//           }
//         }
//       });
//     });
//   };

//   document.querySelectorAll('.play_video').forEach(button => {
//     button.addEventListener('click', function () {
//       const parent = this.closest('.review_img_video');
//       const iframe = parent.querySelector('iframe[src*="youtube"]');
//       const video = parent.querySelector('video');

//       // 🔁 Pause all other videos first
//       document.querySelectorAll('.review_img_video').forEach(other => {
//         if (other !== parent) {
//           // Pause YouTube iframe if exists
//           const otherIframe = other.querySelector('iframe[src*="youtube"]');
//           if (otherIframe && youtubePlayers.has(otherIframe)) {
//             youtubePlayers.get(otherIframe).pauseVideo();
//           }

//           // Pause native video if exists
//           const otherVideo = other.querySelector('video');
//           if (otherVideo && !otherVideo.paused) {
//             otherVideo.pause();
//           }

//           other.classList.remove('playing');
//           other.classList.remove('played');
//         }
//       });

//       // ▶️ Play clicked video
//       if (iframe && youtubePlayers.has(iframe)) {
//         const player = youtubePlayers.get(iframe);
//         const isPlaying = parent.classList.contains('playing');

//         if (isPlaying) {
//           player.pauseVideo();
//           parent.classList.remove('playing');
//           parent.classList.remove('played');
//         } else {
//           player.playVideo();
//           parent.classList.add('playing');
//           parent.classList.add('played');
//         }

//       } else if (video) {
//         if (video.paused) {
//           video.play();
//           parent.classList.add('playing');
//           parent.classList.add('played');
//         } else {
//           video.pause();
//           parent.classList.remove('playing');
//           parent.classList.remove('played');
//         }

//         // These listeners can be set once per video in setup if needed
//         video.addEventListener('play', () => parent.classList.add('playing'));
//         video.addEventListener('pause', () => parent.classList.remove('playing'));
//       } else {
//         parent.classList.toggle('playing');
//         parent.classList.toggle('played');
//       }

//       if (!parent.classList.contains('played')) {
//         parent.classList.add('played');
//       }
//     });
//   });
// });


// Swiper Slider Settings

document.querySelectorAll('.play_video').forEach(button => {
    button.addEventListener('click', function() {
        const video = this.parentElement.querySelector('video');
        const parent = this.closest('.review_img_video');

        if (video) {
            if (video.paused) {
                video.play();
            } else {
                video.pause();
            }
            video.addEventListener('play', function() {
                parent.classList.add('playing');
            });
            video.addEventListener('pause', function() {
                parent.classList.remove('playing');
            });
        } else {
            parent.classList.toggle('playing');
        }

        if (parent && !parent.classList.contains('played')) {
            parent.classList.add('played');
        }
    });
});

document.addEventListener('DOMContentLoaded', function () {
  function destroySwiper(swiper) {
    if (swiper && swiper.destroy) {
      swiper.destroy(true, true);
    }
  }

  function generateUniqueId() {
    return 'swiper-' + Math.random().toString(36).substr(2, 9);
  }

  function initSwiper(slider) {
    var desktopColumns = parseInt(slider.getAttribute('desktop-column'));
    var tabletColumns = parseInt(slider.getAttribute('tablet-column'));
    var mobileColumns = parseInt(slider.getAttribute('mobile-column'));
    var enablePagination = slider.getAttribute('pagination');
    var enableArrows = slider.getAttribute('arrows');
    var enableScrollbar = slider.getAttribute('scrollbar');
    var enableAutoplay = slider.getAttribute('autoplay') === 'true';
    var autoplayDelay = parseInt(slider.getAttribute('slider-delay'));
    var enableLoop = slider.getAttribute('loop') === 'true';
    var sliderSpaceBetween = parseInt(slider.getAttribute('slider-space-between'));

    var paginationId = generateUniqueId();
    var nextArrowId = generateUniqueId();
    var prevArrowId = generateUniqueId();
    var scrollbarId = generateUniqueId();

    var paginationEl = slider.querySelector('.swiper-pagination');
    var nextArrowEl = slider.querySelector('.swiper-button-next');
    var prevArrowEl = slider.querySelector('.swiper-button-prev');
    var scrollbarEl = slider.querySelector('.swiper-scrollbar');

    if (enablePagination && paginationEl) {
      paginationEl.id = paginationId;
    }
    if (enableArrows && nextArrowEl && prevArrowEl) {
      nextArrowEl.id = nextArrowId;
      prevArrowEl.id = prevArrowId;
    }
    if (enableScrollbar && scrollbarEl) {
      scrollbarEl.id = scrollbarId;
    }

    return new Swiper(slider, {
      slidesPerView: mobileColumns,
      spaceBetween: sliderSpaceBetween,
      pagination: enablePagination && paginationEl ? { el: `#${paginationId}`, clickable: true } : false,
      navigation: enableArrows && nextArrowEl && prevArrowEl ? {
        nextEl: `#${nextArrowId}`,
        prevEl: `#${prevArrowId}`,
      } : false,
      scrollbar: enableScrollbar && scrollbarEl ? { el: `#${scrollbarId}`, draggable: true } : false,
      autoplay: enableAutoplay ? {
        delay: autoplayDelay,
        disableOnInteraction: false,
      } : false,
      loop: enableLoop,
      breakpoints: {
        1025: {
          slidesPerView: desktopColumns,
        },
        768: {
          slidesPerView: tabletColumns,
        },
      },
    });
  }

  function loadSliders() {
    var sections = document.querySelectorAll('[id^="section-"]');

    sections.forEach(function (section) {
      var sliders = section.querySelectorAll('.swiper-desktop-and-mobile, .swiper-desktop, .swiper-mobile');

      sliders.forEach(function (slider) {
        var isDesktop = window.matchMedia('(min-width: 768px)').matches;
        var isMobile = window.matchMedia('(max-width: 767px)').matches;
        var currentSwiper = slider.swiper;

        destroySwiper(currentSwiper);

        if (
          (slider.classList.contains('swiper-desktop-and-mobile')) ||
          (slider.classList.contains('swiper-desktop') && isDesktop) ||
          (slider.classList.contains('swiper-mobile') && isMobile)
        ) {
          slider.swiper = initSwiper(slider);
        }
      });
    });
  }

  function resizeSliders() {
    window.addEventListener('resize', function () {
      loadSliders();
    });
  }

  loadSliders();
  resizeSliders();
});

// document.addEventListener("DOMContentLoaded", function() {
//   if (document.querySelector('.cart-promotions-slider')) {
//     new Swiper('.cart-promotions-slider', {
//       slidesPerView: 'auto',
//       spaceBetween: 0,
//       loop: true,
//       pagination: {
//         el: '.swiper-pagination',
//         clickable: true,
//       }
//     });
//      window.addEventListener("resize", function() {
//       cartSwiper.update();
//     });
//   }
// });

// window.updatePromotionsSlider = function() {
//   const cartPromotionsSliders = document.querySelectorAll('.cart-promotions-slider');
//   if (cartPromotionsSliders.length > 0) {
//     cartPromotionsSliders.forEach(function (cartSlider) {
//       var _swiper = new Swiper(cartSlider, {
//         slidesPerView: 'auto',
//         spaceBetween: 0,
//         loop: true,
//         pagination: {
//           el: '.swiper-pagination',
//           clickable: true,
//         }
//       });
//       window.addEventListener("resize", function() {
//         _swiper.update();
//       });
//     });
//   }
// }

// window.updatePromotionsSlider();

window.updatePromotionsSlider = function () {
  const cartPromotionsSliders = document.querySelectorAll('.cart-promotions-slider');

  if (cartPromotionsSliders.length > 0) {
    cartPromotionsSliders.forEach(function (cartSlider) {
      const swiperInstance = new Swiper(cartSlider, {
        slidesPerView: 'auto',
        spaceBetween: 0,
        loop: true,
        simulateTouch: true,
        allowTouchMove: true,
        pagination: {
          el: cartSlider.querySelector('.swiper-pagination'),
          clickable: true,
        },
      });

      // Update swiper on window resize
      window.addEventListener('resize', function () {
        swiperInstance.update();
      });
    });
  }
};

// Ensure the DOM is loaded before initializing
document.addEventListener('DOMContentLoaded', function () {
  window.updatePromotionsSlider();
});
